import { useDeviceType } from '@cian/ui-kit';
import { ActionButton } from 'shared/components/ActionButton';
import { BUTTON_TEXT } from 'shared/constants/tracking';
import * as styles from './styles.css';
import { ITEMS } from './constants';
import clsx from 'clsx';

export const MarketLeadershipSection: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['text-block']}>
        <div className={styles['title']}>Продайте и сдайте быстрее с Циан — лидером рынка</div>
        <div className={styles['description']}>среди сервисов по недвижимости в ключевых регионах России</div>
      </div>
      <div className={styles['list']}>
        {ITEMS.map(({ id, image, title, description }) => (
          <div key={id} className={styles['item']}>
            <img className={styles['item-image']} src={image} alt={title} />
            <div className={styles['item-title']}>{title}</div>
            <div className={styles['item-description']}>{description}</div>
          </div>
        ))}
      </div>
      <ActionButton>{BUTTON_TEXT.PLACE_AD}</ActionButton>
    </div>
  );
};
